import { combineReducers } from '@reduxjs/toolkit';
import courseReducer, { courseActions, learningMaterialsReducer } from './course';
import homeReducer, { homeActions } from './home';
import * as Meetings from './meetings';
import * as Meeting from './meeting';
import * as Boards from './boards';
import * as MyLessons from './myLessons';
import * as Assignments from './assignments';
import * as Tests from './tests';
import * as Activity from './activity';
import * as MyProgressRedux from './myProgress';
import * as RewardNotificationsRedux from './rewardNotifications';
import * as WeekCalendar from './weekCalendar';
import selectors from './selectors';

const memberPageReducer = combineReducers({
  homePage: homeReducer,
  coursePage: courseReducer,
  meetingsPage: Meetings.reducer,
  meetingItem: Meeting.reducer,
  boardsPage: Boards.reducer,
  myLessons: MyLessons.reducer,
  assignmentsPage: Assignments.reducer,
  testsPage: Tests.reducer,
  learningMaterials: learningMaterialsReducer,
  activity: Activity.reducer,
  myProgress: MyProgressRedux.reducer,
  rewardNotifications: RewardNotificationsRedux.reducer,
  weekCalendar: WeekCalendar.reducer
});

export default memberPageReducer;

export {
  homeActions,
  courseActions,
  selectors,
  Meetings,
  Meeting,
  Boards,
  MyLessons,
  Assignments,
  Tests,
  Activity,
  MyProgressRedux,
  RewardNotificationsRedux,
  WeekCalendar
};
